import { render, staticRenderFns } from "./LoadOverviewChart.vue?vue&type=template&id=2b22c223&scoped=true"
import script from "./LoadOverviewChart.vue?vue&type=script&lang=js"
export * from "./LoadOverviewChart.vue?vue&type=script&lang=js"
import style0 from "./LoadOverviewChart.vue?vue&type=style&index=0&id=2b22c223&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2b22c223",
  null
  
)

export default component.exports